export const MONTH_LABELS = Array.from({ length: 12 }, (_, i) => `${i + 1}월`);

export const formatWon = (value) => `${(value ?? 0).toLocaleString("ko-KR")}원`;

export const formatKoreanUnit = (value) => {
  const n = value ?? 0;
  if (n === 0) return "0";
  const eok = Math.floor(n / 100000000);
  const man = Math.round(((n % 100000000) / 10000) * 10) / 10;
  const parts = [];
  if (eok > 0) parts.push(`${eok}억`);
  if (man > 0) parts.push(`${man.toLocaleString("ko-KR")}만`);
  return parts.join(" ");
};

export const calcDeltaPercent = (current, base) => {
  if (!base) return null;
  return ((current - base) / base) * 100;
};

export const formatDelta = (percent) => {
  if (percent === null || percent === undefined) return "-";
  const arrow = percent >= 0 ? "▲" : "▼";
  return `${arrow} ${Math.abs(percent).toFixed(1)}%`;
};
